import React, { useEffect, useState } from 'react';
import {
  Button, ButtonToolbar, CheckPicker, Form,
} from 'rsuite';
import { useNavigate } from 'react-router-dom';
import { getPartners } from '../api/partner/partner';
import { Partner } from '../api/partner/partnerApiTypes';
import { createUser } from '../api/userManagement/userManagement';
import handleError from '../api/apiErrorHandle';
import { showSuccessMessage } from '../utils/message';

export default function UserSetup() {
  const navigate = useNavigate();
  const [partners, setPartners] = useState<Partner[]>([]);
  const [newUsername, setUsername] = useState<string>();
  const [newName, setName] = useState<string>();
  const [newPassword, setPassword] = useState<string>();
  const [selectedPartnerCodes, setSelectedPartnerCodes] = useState<string[]>([]);

  useEffect(() => {
    getPartners()
      .then(data => {
        setPartners(data);
      });
  }, []);

  function onSubmit() {
    const request = {
      username: newUsername!,
      name: newName!,
      password: newPassword!,
      partnerCodes: selectedPartnerCodes,
    };

    navigate(-1);
    createUser(request)
      .then(() => showSuccessMessage('User created!'))
      .catch(error => handleError(error));
  }

  return (
    <div className="m-10">
      <h4>Create new user</h4>
      <Form layout="horizontal">
        <Form.Group controlId="username">
          <Form.ControlLabel>Username</Form.ControlLabel>
          <Form.Control onChange={(value: string) => setUsername(value)} name="username" />
        </Form.Group>

        <Form.Group controlId="name">
          <Form.ControlLabel>Name</Form.ControlLabel>
          <Form.Control onChange={(value: string) => setName(value)} name="name" />
        </Form.Group>

        <Form.Group controlId="password">
          <Form.ControlLabel>Password</Form.ControlLabel>
          <Form.Control type="password" onChange={(value: string) => setPassword(value)} name="password" />
        </Form.Group>

        <Form.Group controlId="partners">
          <Form.ControlLabel>Partners</Form.ControlLabel>
          <CheckPicker
            data={partners}
            labelKey="name"
            valueKey="code"
            value={selectedPartnerCodes}
            onChange={(partnerCodes) => setSelectedPartnerCodes(partnerCodes)}
          />
        </Form.Group>

        <Form.Group>
          <ButtonToolbar>
            <Button appearance="primary" onClick={() => onSubmit()}>Submit</Button>
            <Button appearance="ghost" onClick={() => navigate(-1)}>Cancel</Button>
          </ButtonToolbar>
        </Form.Group>
      </Form>
    </div>
  );
}
